import { NotFound } from 'components/common/NotFound';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DisplayTimingGroupListPage from './pages/DisplayTimingGroupListPage';

function DisplayTimingGroupFeature() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <DisplayTimingGroupListPage />
      </Route>
      <Route path="*">
        <NotFound />
      </Route>
    </Switch>
  );
}

export default DisplayTimingGroupFeature;
